module.exports = __webpack_public_path__ + "img/feature_d03.58e6fe28.svg";